import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
function trackHeaderClick({ clickTarget, location }) {
    try {
        const properties = {
            click_target: clickTarget,
            location,
        };
        SegmentUtils.track({
            event: 'Header Click',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackHeaderClick',
        });
    }
}
export default trackHeaderClick;
